import { auditProductActions } from '../config/actions';

const defaultState = {
  isLoading: null,
  data: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case auditProductActions.SCAN_PRODUCT_AUDIT_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || [],
        error: null
      };
    case auditProductActions.SCAN_PRODUCT_AUDIT_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        error: action.error,
        history: state.history || []
      };
    case auditProductActions.SCAN_PRODUCT_AUDIT_NEW:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        error: null
      };
    case auditProductActions.SCAN_PRODUCT_AUDIT:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        error: null
      };
    case auditProductActions.SCAN_PRODUCT_AUDIT_RESET:
      return {
        ...state,
        isLoading: false,
        data: [],
        error: action.message
      };
    default:
      return state;
  }
};
